/* eslint-disable import/no-import-module-exports */
import 'core-js/web/url';
import React from 'react';
import { render } from 'react-dom';
import { Brander } from '@express-labs/raven-brander';
import { ApolloProvider } from '@apollo/react-hooks';

import App from './App';
import './index.scss';

import * as serviceWorker from './serviceWorker';
import client from './appState/ravenApolloClient';
import configureGlobals from './appState/ravenConfigureGlobals';
import HeaderData from './contexts/HeaderData';
import HeaderDynamicData from './contexts/HeaderDynamicData';

if (module.hot) {
  module.hot.accept();
}

configureGlobals();

render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <Brander>
        <HeaderDynamicData>
          <HeaderData>
            <App />
          </HeaderData>
        </HeaderDynamicData>
      </Brander>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// Testing
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
